// extracted by mini-css-extract-plugin
export var closeButton = "_4-5";
export var container = "_4-0";
export var contentContainer = "_4-1";
export var desktop = "_4-2";
export var fullModalImage = "_4-6";
export var mobile = "_4-3";
export var withImage = "_4-4";